import { makeStyles } from '@material-ui/core';

export const useStyle = makeStyles(theme => {
	const {
		palette,
		breakpoints: { down },
		spacing,
	} = theme;
	return {
		paper: {
			background: palette.primary.main,
			display: 'flex',
			justifyContent: 'left',
			flexDirection: 'start',
			alignItems: 'center',
			textAlign: 'left',
			color: 'white',
			padding: spacing(2.5),
			fontFamily: 'Montserrat',
			borderRadius: '2px !important',
			[down('sm')]: {
				padding: spacing(0, 0, 0, 1),
				height: spacing(8),
				borderLeft: `9px solid ${palette.action.main}`,
			},
		},
		title: {
			fontFamily: 'Montserrat',
			fontSize: 17,
			clear: 'both',
			[down('sm')]: {
				fontSize: '0.9rem',
				fontWeight: '300',
			},
		},
		greenLabel: {
			borderRadius: 2,
			background: palette.action.main,
			width: 10,
			height: 35,
			float: 'left',
			margin: spacing(-4, 2, 0, 2),
			[down('sm')]: {
				display: 'none',
			},
		},
	};
});
